import { LANGUAGE_TO_COUNTRY } from '@/shared/config';
import type { Country, Language, LanguageSelectOption } from '@/shared/types';

export const buildLanguageSelectOptions = (
  countries: Country[]
): LanguageSelectOption[] => {
  return (Object.keys(LANGUAGE_TO_COUNTRY) as Language[]).map(lang => {
    const countryCode = LANGUAGE_TO_COUNTRY[lang];
    const country = countries.find(c => c.code.toLowerCase() === countryCode);

    return {
      value: lang,
      code: lang,
      icon: country?.link ?? '',
    };
  });
};
